/* ============================================================================
   ALIA · booking widget + the three calls to action

   THREE ACTIONS, everywhere on the site:
     CORPORATE   -> opens the private-events lead form   (the priority action)
     RESTAURANT  -> OpenTable                            (outbound link)
     CLUB        -> phone                                (tel: link)

   Shadow-DOM isolated. Two things cross the boundary by design:
     1. @font-face is document-scoped, so the theme's Chivo faces resolve here.
     2. Inherited custom properties, so every colour below is the theme's OWN
        token with a literal fallback, never a copy of the reference palette.

   Carries no GSAP, ScrollTrigger or Lenis, so the single smooth-scroll instance
   and single ScrollTrigger registry in 03-velvet.js stay the only motion system.
   ========================================================================== */

(function () {
  'use strict';

  /* ── configuration ─────────────────────────────────────────────────────
     Verified against aliamtl.com. Override via window.ALIA_WIDGET. */
  /* Config is emitted inline in <head> by layout/theme.liquid out of theme
     settings, so it exists before this deferred script runs. There is NO email
     anywhere in this file by client instruction: if the post fails, the form
     shows the phone. */
  var C = window.ALIA_CFG || {};
  var CFG = {
    phoneLabel: C.phoneDisplay || '(514) 566-2542',
    phone:      C.phoneHref    || 'tel:+15145662542',
    opentable:  C.openTable    || 'https://www.opentable.ca/r/alia-montreal',
    endpoint:   C.endpoint     || '',
    site:       C.site         || '',
    hideThemeDock: true
  };
  var over = window.ALIA_WIDGET || {};
  for (var k in over) { if (Object.prototype.hasOwnProperty.call(over, k)) CFG[k] = over[k]; }
  /* no endpoint configured means the form genuinely cannot deliver */
  var DEMO = !CFG.endpoint;

  if (document.getElementById('alia-wgt-host')) return;
  if (!document.body) { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/"/g, '&quot;')
      .replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function boot() {

  var CSS = `
  :host{
    --w-ground:     var(--roast,   #241A11);
    --w-deep:       var(--roast2,  #4A331F);
    --w-accent:     var(--amber,   #8A5F3A);
    --w-ink:        var(--bone,    #EEEDE3);
    --w-accent-rgb: var(--amber-rgb, 138,95,58);
    --w-ink-rgb:    var(--bone-rgb,  238,237,227);
    --w-ground-rgb: var(--roast-rgb, 36,26,17);
    --w-go:         var(--cta-green,      #1FA35B);
    --w-go-dark:    var(--cta-green-dark, #17824A);
    --w-go-deep:    var(--cta-green-deep, #115C35);
    --w-ease:       var(--ease, cubic-bezier(.19,1,.22,1));
    --w-sans:'Chivo',system-ui,sans-serif;
    --w-mono:'Chivo Mono',ui-monospace,monospace;
    /* Field well, deliberately LIGHTER than the card so it reads as somewhere
       to type. Opaque, never translucent (trap C). */
    --w-well:#332619;
    --w-well-hover:#3D2E1E;
    --w-well-focus:#453425;
    /* trap B: 3.04:1 from the value colour, 4.11:1 from the well, so an empty
       field can never be mistaken for a filled one */
    --w-ph:#93866F;
    --w-bad:#C4713F;
    --w-r:6px;

    position:fixed; inset:0; pointer-events:none;
    /* under the preloader (10000) and the custom cursor (9998/9999),
       over the nav (1200) and the progress bar (1300) */
    z-index:9400;
    font-family:var(--w-sans); font-weight:300; line-height:1.5;
    color:var(--w-ink); -webkit-font-smoothing:antialiased;
  }
  *{margin:0;padding:0;box-sizing:border-box}
  button{font-family:inherit;cursor:pointer;background:none;border:none;color:inherit}
  a{color:inherit;text-decoration:none}
  :focus-visible{outline:2px solid var(--w-accent);outline-offset:3px}
  ::selection{background:var(--w-accent);color:var(--w-ground)}
  [hidden]{display:none!important}

  /* ══════════ LAUNCHER: green disc, white question mark ══════════ */
  .fab{
    position:absolute;
    right:clamp(.9rem,2.5vw,1.6rem);
    bottom:calc(clamp(.9rem,2.5vw,1.6rem) + env(safe-area-inset-bottom,0px));
    width:58px;height:58px;border-radius:50%;
    background:var(--w-go);
    border:1px solid var(--w-go-dark);
    color:#fff;
    font-family:var(--w-sans);font-size:27px;font-weight:700;line-height:1;
    display:grid;place-items:center;pointer-events:auto;
    box-shadow:0 10px 34px -8px rgba(0,0,0,.7),inset 0 1px 0 rgba(255,255,255,.28);
    opacity:0;transform:translateY(14px);
    transition:opacity .5s ease,transform .3s var(--w-ease),background .25s ease;
  }
  .fab.revealed{opacity:1;transform:none}
  .fab:hover{background:var(--w-go-dark);transform:scale(1.06)}
  .fab::before{
    content:"";position:absolute;inset:-7px;border-radius:50%;
    border:1px solid var(--w-go);opacity:.45;pointer-events:none;
    animation:halo 3.4s ease-in-out infinite;
  }
  @keyframes halo{0%,100%{transform:scale(1);opacity:.45}50%{transform:scale(1.12);opacity:0}}
  .fab-glyph{display:block;transition:transform .3s var(--w-ease)}
  .fab.open .fab-glyph{transform:rotate(90deg)}

  /* ══════════ PANEL: three ways in ══════════ */
  .panel{
    position:absolute;
    right:clamp(.9rem,2.5vw,1.6rem);
    bottom:calc(clamp(.9rem,2.5vw,1.6rem) + 70px + env(safe-area-inset-bottom,0px));
    width:min(330px,calc(100vw - 2 * clamp(.9rem,2.5vw,1.6rem)));
    pointer-events:auto;
    /* opaque colour, gradient in background-image (trap C) */
    background-color:var(--w-ground);
    background-image:linear-gradient(180deg,var(--w-deep),var(--w-ground));
    border:1px solid rgba(var(--w-accent-rgb),.45);
    border-radius:var(--w-r);
    box-shadow:inset 0 1px 0 rgba(var(--w-accent-rgb),.3),0 26px 60px -18px rgba(0,0,0,.9);
    padding:20px;
    display:flex;flex-direction:column;gap:8px;
    animation:rise .3s var(--w-ease);
  }
  @keyframes rise{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:none}}
  .panel-title{font-size:17px;font-weight:700;letter-spacing:.01em;line-height:1.2}
  .panel-sub{font-size:13.5px;color:rgba(var(--w-ink-rgb),.66);margin-bottom:8px}
  .panel-note{
    margin-top:10px;font-family:var(--w-mono);font-size:10.5px;
    letter-spacing:.14em;text-transform:uppercase;color:var(--w-accent);
  }

  /* ══════════ BUTTONS ══════════ */
  .b{
    display:flex;align-items:center;justify-content:center;gap:8px;
    width:100%;min-height:44px;padding:13px 16px;
    border-radius:var(--w-r);
    font-family:var(--w-mono);font-weight:500;font-size:11.5px;
    letter-spacing:.16em;text-transform:uppercase;text-align:center;
    position:relative;overflow:hidden;
    transition:border-color .3s var(--w-ease),box-shadow .3s var(--w-ease),transform .3s var(--w-ease);
  }
  /* Corporate: filled. Deep green so white type clears AA at 4.85:1. */
  .b-fill{
    background-color:var(--w-go-dark);
    background-image:linear-gradient(180deg,var(--w-go-dark),var(--w-go-deep));
    border:1px solid var(--w-go);
    color:#fff;
    box-shadow:inset 0 1px 0 rgba(255,255,255,.22),0 6px 18px rgba(0,0,0,.3);
  }
  .b-fill:hover{border-color:#fff;box-shadow:inset 0 1px 0 rgba(255,255,255,.4),0 8px 22px rgba(0,0,0,.36);transform:translateY(-1px)}
  /* Ghost: bone label inside a green frame. Bone clears AA on both grounds;
     green type would only manage 3.61:1 on the deep roast. */
  .b-ghost{
    background:transparent;
    border:1px solid var(--w-go);
    color:var(--w-ink);
  }
  .b-ghost:hover{
    background-color:var(--w-go-dark);
    background-image:linear-gradient(180deg,var(--w-go-dark),var(--w-go-deep));
    color:#fff;transform:translateY(-1px);
  }

  /* ══════════ LEAD FORM ══════════ */
  .scrim{
    position:absolute;inset:0;display:none;align-items:center;justify-content:center;
    padding:clamp(12px,2.4vw,26px);pointer-events:auto;
    background:rgba(var(--w-ground-rgb),.84);
    -webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px);
  }
  .scrim.on{display:flex}
  .modal{
    position:relative;width:min(660px,100%);
    max-height:calc(100vh - 2 * clamp(12px,2.4vw,26px));
    display:flex;flex-direction:column;
    background-color:var(--w-ground);
    border:1px solid rgba(var(--w-accent-rgb),.3);
    border-top:2px solid var(--w-go);
    border-radius:var(--w-r);
    box-shadow:0 40px 90px -24px rgba(0,0,0,.95);
    animation:rise .3s var(--w-ease);
  }
  .m-head{
    flex:none;display:flex;justify-content:space-between;align-items:flex-start;gap:20px;
    padding:clamp(18px,2.2vw,26px) clamp(18px,2.4vw,28px) clamp(14px,1.6vw,20px);
    border-bottom:1px solid rgba(var(--w-accent-rgb),.22);
  }
  .m-eye{font-family:var(--w-mono);font-weight:400;font-size:10px;letter-spacing:.34em;text-transform:uppercase;color:var(--w-accent)}
  .m-title{font-size:clamp(21px,2.6vw,27px);font-weight:300;letter-spacing:-.01em;line-height:1.15;margin:8px 0 6px}
  .m-sub{font-size:13.5px;color:rgba(var(--w-ink-rgb),.66);max-width:46ch}
  .m-x{
    flex:none;width:34px;height:34px;border-radius:3px;
    border:1px solid rgba(var(--w-accent-rgb),.3);color:rgba(var(--w-ink-rgb),.7);
    font-size:17px;line-height:1;transition:color .2s,border-color .2s;
  }
  .m-x:hover{color:var(--w-ink);border-color:var(--w-accent)}
  .m-body{flex:1 1 auto;min-height:0;overflow-y:auto;padding:clamp(16px,2vw,24px) clamp(18px,2.4vw,28px) clamp(20px,2.4vw,28px)}

  .grid{display:grid;grid-template-columns:1fr 1fr;gap:12px}
  .span2{grid-column:1 / -1}
  .fld{display:flex;flex-direction:column;gap:6px;min-width:0}
  .fld > label{font-family:var(--w-mono);font-size:10px;letter-spacing:.2em;text-transform:uppercase;color:var(--w-accent)}
  .fld .opt{color:rgba(var(--w-accent-rgb),.66)}
  .fld input,.fld select,.fld textarea{
    font-family:var(--w-sans);font-weight:300;
    font-size:16px;              /* 16px stops iOS zooming the page on focus */
    color:var(--w-ink);
    background:var(--w-well);
    border:0;border-radius:4px;padding:12px 13px;width:100%;
    box-shadow:inset 0 0 0 1px rgba(var(--w-accent-rgb),.55),inset 0 1px 0 rgba(var(--w-ink-rgb),.14);
    transition:background .16s ease,box-shadow .16s ease;
  }
  .fld textarea{resize:vertical;min-height:74px;font-size:15px;line-height:1.55}
  .fld input::placeholder,.fld textarea::placeholder{color:var(--w-ph);opacity:1}
  .fld input:hover,.fld select:hover,.fld textarea:hover{background:var(--w-well-hover)}
  .fld input:focus,.fld select:focus,.fld textarea:focus{
    outline:none;background:var(--w-well-focus);
    box-shadow:inset 0 0 0 2px var(--w-go),0 0 0 4px rgba(31,163,91,.16);
  }
  /* an unchosen select and an empty date both paint in the full value colour,
     which makes the least complete field read as the most complete */
  .fld select.is-empty,.fld:not(.is-filled) input[type="date"]{color:var(--w-ph)}
  .fld select{appearance:none;-webkit-appearance:none;cursor:pointer;padding-right:32px}
  .sel{position:relative}
  .sel::after{content:"";position:absolute;right:13px;top:50%;margin-top:-2px;border:4px solid transparent;border-top-color:var(--w-accent);pointer-events:none}
  .fld input[type="number"]{-moz-appearance:textfield;appearance:textfield}
  .fld input[type="number"]::-webkit-outer-spin-button,
  .fld input[type="number"]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}
  /* a filled field earns a green rail, so completeness reads down the form */
  .fld.is-filled:not(.is-bad) input,.fld.is-filled:not(.is-bad) select,.fld.is-filled:not(.is-bad) textarea{
    box-shadow:inset 4px 0 0 var(--w-go),inset 0 0 0 1px rgba(var(--w-accent-rgb),.55);
  }
  .fld.is-bad input,.fld.is-bad select,.fld.is-bad textarea{
    box-shadow:inset 4px 0 0 var(--w-bad),inset 0 0 0 1px var(--w-bad);
  }
  .err{display:none;font-family:var(--w-mono);font-size:9.5px;letter-spacing:.1em;text-transform:uppercase;color:#E0705E}
  .fld.is-bad .err{display:block}

  .m-foot{
    display:flex;align-items:center;justify-content:space-between;gap:14px;flex-wrap:wrap;
    margin-top:18px;padding-top:16px;border-top:1px solid rgba(var(--w-accent-rgb),.22);
  }
  .m-foot p{font-size:12.5px;color:rgba(var(--w-ink-rgb),.6);max-width:34ch}
  .m-send{width:auto;min-width:170px}
  .m-send[disabled]{opacity:.6;pointer-events:none}

  /* ══════════ CONFIRMATION ══════════ */
  .done{display:flex;flex-direction:column;gap:14px}
  .done-mark{width:44px;height:44px;border-radius:50%;background:var(--w-go-dark);color:#fff;display:grid;place-items:center;font-size:21px;font-weight:700}
  .done-h{font-size:clamp(20px,2.4vw,25px);font-weight:300;letter-spacing:-.01em;line-height:1.15}
  .done-lede{font-size:14.5px;color:rgba(var(--w-ink-rgb),.7);max-width:48ch}
  .done-lede b{color:var(--w-ink);font-weight:700}
  .sum{display:grid;gap:1px;background:rgba(var(--w-accent-rgb),.22);border:1px solid rgba(var(--w-accent-rgb),.22);border-radius:4px;overflow:hidden}
  .sum > div{background:var(--w-ground);padding:10px 14px;display:flex;justify-content:space-between;gap:16px;font-size:13px}
  .sum dt{font-family:var(--w-mono);font-size:10px;letter-spacing:.16em;text-transform:uppercase;color:var(--w-accent)}
  .sum dd{text-align:right;color:var(--w-ink)}
  .done-next{border-top:1px solid rgba(var(--w-accent-rgb),.22);padding-top:14px;display:flex;flex-direction:column;gap:10px}
  .done-actions{display:flex;gap:10px;flex-wrap:wrap}
  .done-actions .b{width:auto;min-width:0;flex:1 1 auto}

  @media(max-width:600px){
    .fab{right:14px;bottom:calc(14px + env(safe-area-inset-bottom,0px))}
    .panel{right:14px;bottom:calc(14px + 70px + env(safe-area-inset-bottom,0px));width:min(300px,calc(100vw - 28px))}
    .scrim{padding:12px}
    .m-title{font-size:20px;margin:6px 0 5px}
    .m-sub{font-size:13px}
    .fld input,.fld select,.fld textarea{padding:10px 12px}
    .m-send{width:100%}
  }
  /* paired fields keep their columns down to the smallest phones: collapsing
     them doubles the row count and is what makes the form scroll */
  @media(max-height:820px){
    .m-title{font-size:20px;margin:6px 0 5px}
    .m-sub{display:none}
    .grid{gap:9px}
    .fld{gap:4px}
    .fld input,.fld select,.fld textarea{padding:9px 11px;font-size:15px}
    .fld textarea{min-height:58px}
    .m-foot{margin-top:12px;padding-top:12px}
  }
  @media(max-height:700px){
    .fld textarea{min-height:48px}
    .m-foot p{display:none}
  }
  @media(prefers-reduced-motion:reduce){
    *{animation:none!important;transition:none!important}
    .fab{opacity:1;transform:none}
  }
  `;

  /* ══════════════════════════════════════════════════════════════════════
     MARKUP
     ══════════════════════════════════════════════════════════════════════ */
  var HTML =
  '<div class="panel" id="alia-panel" role="dialog" aria-label="Three ways to reach ALIA" hidden>' +
    '<p class="panel-title">Three ways in</p>' +
    '<p class="panel-sub">Which one are you here for?</p>' +
    '<button class="b b-fill" type="button" data-act="corp">Corporate &middot; Private events</button>' +
    '<a class="b b-ghost" data-act="rest" href="' + esc(CFG.opentable) + '" target="_blank" rel="noopener">Restaurant &middot; Book a table</a>' +
    '<a class="b b-ghost" data-act="club" href="' + esc(CFG.phone) + '">Club &middot; Call the door</a>' +
    '<p class="panel-note">' + esc(CFG.phoneLabel) + '</p>' +
  '</div>' +

  '<button class="fab" id="alia-fab" type="button" aria-label="How to reach us" aria-expanded="false" aria-controls="alia-panel">' +
    '<span class="fab-glyph" aria-hidden="true">?</span>' +
  '</button>' +

  '<div class="scrim" data-scrim>' +
    '<div class="modal" role="dialog" aria-modal="true" aria-labelledby="alia-mt">' +
      '<div class="m-head">' +
        '<div>' +
          '<p class="m-eye">Private events</p>' +
          '<h2 class="m-title" id="alia-mt">Request a date</h2>' +
          '<p class="m-sub" data-msub>Tell us the night, the size and the shape of the evening. We will come back to you by email.</p>' +
        '</div>' +
        '<button class="m-x" data-mclose type="button" aria-label="Close">&#215;</button>' +
      '</div>' +
      '<div class="m-body">' +
        '<form data-form novalidate>' +
          '<div class="grid">' +
            '<div class="fld" data-fld="Name"><label for="af-name">Your name</label><input id="af-name" name="Name" type="text" autocomplete="name" placeholder="Alex Tremblay" required><span class="err">Required</span></div>' +
            '<div class="fld" data-fld="Company"><label for="af-co">Company</label><input id="af-co" name="Company" type="text" autocomplete="organization" placeholder="Northbound Capital" required><span class="err">Required</span></div>' +
            '<div class="fld" data-fld="Email"><label for="af-em">Work email</label><input id="af-em" name="Email" type="email" autocomplete="email" placeholder="you@company.com" required><span class="err">Enter a valid email</span></div>' +
            '<div class="fld" data-fld="Phone"><label for="af-ph">Phone</label><input id="af-ph" name="Phone" type="tel" autocomplete="tel" inputmode="tel" placeholder="514 000 0000" required><span class="err">Required</span></div>' +
            '<div class="fld" data-fld="Event type"><label for="af-ev">Event</label><div class="sel">' +
              '<select id="af-ev" name="Event type" required>' +
                '<option value="" selected>Choose one</option>' +
                '<option>Year-end party</option>' +
                '<option>Client dinner</option>' +
                '<option>Full buyout</option>' +
                '<option>Cocktail reception</option>' +
                '<option>Product launch</option>' +
                '<option>Something else</option>' +
              '</select></div><span class="err">Required</span></div>' +
            '<div class="fld" data-fld="Guests"><label for="af-gu">Guests</label><input id="af-gu" name="Guests" type="number" min="1" max="400" inputmode="numeric" placeholder="60" required><span class="err">Required</span></div>' +
            '<div class="fld span2" data-fld="Event detail" hidden><label for="af-eo">Tell us which</label><input id="af-eo" name="Event detail" type="text" placeholder="What kind of evening"><span class="err">Required</span></div>' +
            '<div class="fld" data-fld="Preferred date"><label for="af-dt">Preferred date</label><input id="af-dt" name="Preferred date" type="date" required><span class="err">Required</span></div>' +
            '<div class="fld" data-fld="Budget per head"><label for="af-bu">Budget per head <span class="opt">(optional)</span></label><input id="af-bu" name="Budget per head" type="text" placeholder="Optional"><span class="err">Required</span></div>' +
            '<div class="fld span2" data-fld="Notes"><label for="af-no">Anything we should know <span class="opt">(optional)</span></label><textarea id="af-no" name="Notes" rows="2" placeholder="Dietary needs, AV, a speech, a hard end time."></textarea><span class="err">Required</span></div>' +
          '</div>' +
          '<div class="m-foot">' +
            '<p>We will confirm availability by email.</p>' +
            '<button class="b b-fill m-send" data-msend type="submit">Send request</button>' +
          '</div>' +
        '</form>' +

        '<div class="done" data-done hidden aria-live="polite">' +
          '<div class="done-mark" aria-hidden="true">&#10003;</div>' +
          '<div><h3 class="done-h" data-dtitle>Thank you.</h3><p class="done-lede" data-dlede></p></div>' +
          '<dl class="sum" data-sum></dl>' +
          '<div class="done-next">' +
            '<p class="m-eye">If you need us sooner</p>' +
            '<div class="done-actions">' +
              '<a class="b b-ghost" href="' + esc(CFG.phone) + '">Call ' + esc(CFG.phoneLabel) + '</a>' +
              '<button class="b b-ghost" data-dagain type="button" hidden>Send another request</button>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</div>' +
  '</div>';

  /* ══════════════════════════════════════════════════════════════════════
     MOUNT
     ══════════════════════════════════════════════════════════════════════ */
  var host = document.createElement('div');
  host.id = 'alia-wgt-host';
  document.body.appendChild(host);
  var root = host.attachShadow({ mode: 'open' });
  root.innerHTML = '<style>' + CSS + '</style>' + HTML;

  if (CFG.hideThemeDock) {
    var hide = document.createElement('style');
    hide.id = 'alia-wgt-dock-hide';
    hide.textContent = '.alia-cta-dock{display:none!important}';
    document.head.appendChild(hide);
  }

  var fab     = root.getElementById('alia-fab');
  var panel   = root.getElementById('alia-panel');
  var scrim   = root.querySelector('[data-scrim]');
  var modal   = root.querySelector('.modal');
  var form    = root.querySelector('[data-form]');
  var sendBtn = root.querySelector('[data-msend]');
  var doneEl  = root.querySelector('[data-done]');
  var sumEl   = root.querySelector('[data-sum]');
  var otherFld = root.querySelector('[data-fld="Event detail"]');
  var otherIn  = form.elements['Event detail'];

  /* ── reveal once the preloader has cleared ── */
  (function () {
    function show() { fab.classList.add('revealed'); }
    if (!document.getElementById('pre')) { show(); return; }
    var start = new Date().getTime();
    var iv = setInterval(function () {
      var el = document.getElementById('pre');
      var gone = !el;
      if (el) {
        var cs = getComputedStyle(el);
        gone = cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) < 0.1;
      }
      if (gone || (new Date().getTime() - start) > 6000) { show(); clearInterval(iv); }
    }, 200);
  })();

  /* ── panel ── */
  function setPanel(open) {
    panel.hidden = !open;
    fab.classList.toggle('open', open);
    fab.setAttribute('aria-expanded', open ? 'true' : 'false');
    fab.querySelector('.fab-glyph').textContent = open ? '×' : '?';
  }
  fab.addEventListener('click', function () { setPanel(panel.hidden); });
  /* clicking anywhere else closes it. Shadow clicks retarget to the host. */
  document.addEventListener('click', function (e) {
    if (panel.hidden) return;
    if (e.target === host) return;
    setPanel(false);
  });

  /* ══════════════════════════════════════════════════════════════════════
     TRAP A — the corporate handler lives on `document` and walks
     composedPath(), so ONE listener covers both the buttons inside this
     shadow root and every data-act="corp" button out on the page. A listener
     bound to the shadow root would never see the page buttons at all.
     ══════════════════════════════════════════════════════════════════════ */
  function corpTargetFrom(e) {
    var path = (e.composedPath && e.composedPath()) || [];
    for (var i = 0; i < path.length; i++) {
      var n = path[i];
      if (!n || n.nodeType !== 1 || !n.getAttribute) continue;
      if (n.getAttribute('data-act') === 'corp' || n.hasAttribute('data-alia-corporate')) return n;
    }
    /* browsers without composedPath still resolve light-DOM buttons */
    if (e.target && e.target.closest) {
      return e.target.closest('[data-act="corp"],[data-alia-corporate]');
    }
    return null;
  }
  document.addEventListener('click', function (e) {
    if (!corpTargetFrom(e)) return;
    e.preventDefault();
    setPanel(false);
    openForm();
  });
  window.ALIA_WIDGET_OPEN_CORPORATE = openForm;

  /* ══════════════════════════════════════════════════════════════════════
     SESSION GUARD
     The commonest duplicate is not a double click — the button is already
     disabled during the fetch. It is someone who sends a request, closes the
     modal, reopens it out of curiosity, and finds their details still typed in
     behind a live Send button.

     So a delivered request is remembered for the browser SESSION and reopening
     lands on the confirmation. sessionStorage, not localStorage: a new tab or a
     later visit starts clean. Every access is wrapped because Safari private
     mode throws on write — a storage failure must mean NO GUARD, never a
     broken form. It is a nudge against an accidental double send, not a
     lockout: "Send another request" clears it deliberately.
     ══════════════════════════════════════════════════════════════════════ */
  var SENT_KEY = 'alia-req-sent';
  function readSent() {
    try { return JSON.parse(sessionStorage.getItem(SENT_KEY) || 'null'); }
    catch (err) { return null; }
  }
  function rememberSent(p) {
    try { sessionStorage.setItem(SENT_KEY, JSON.stringify({ data: p.data, text: p.text })); }
    catch (err) {}
  }
  function forgetSent() {
    try { sessionStorage.removeItem(SENT_KEY); } catch (err) {}
  }

  /* ── form open / close ── */
  var lastFocus = null;
  function openForm() {
    lastFocus = document.activeElement;

    var prior = readSent();
    if (prior && prior.data) {
      rebuildSummary(prior);
      confirmView(prior, true, true);
      scrim.classList.add('on');
      return;
    }

    form.hidden = false;
    doneEl.hidden = true;
    root.getElementById('alia-mt').textContent = 'Request a date';
    root.querySelector('[data-msub]').textContent =
      'Tell us the night, the size and the shape of the evening. We will come back to you.';
    scrim.classList.add('on');
    setTimeout(function () { var f = form.elements['Name']; if (f) f.focus(); }, 40);
  }
  function closeForm() {
    scrim.classList.remove('on');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  root.querySelector('[data-mclose]').addEventListener('click', closeForm);
  scrim.addEventListener('click', function (e) { if (e.target === scrim) closeForm(); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (scrim.classList.contains('on')) closeForm();
      else if (!panel.hidden) setPanel(false);
      return;
    }
    if (e.key !== 'Tab' || !scrim.classList.contains('on')) return;
    var f = [].slice.call(modal.querySelectorAll('button,input,select,textarea,a[href]'))
      .filter(function (el) { return el.offsetParent !== null || el === document.activeElement; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1], active = root.activeElement;
    if (e.shiftKey && active === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && active === last) { e.preventDefault(); first.focus(); }
  });

  /* a date in the past helps nobody */
  form.elements['Preferred date'].min = new Date().toISOString().slice(0, 10);

  /* ══════════════════════════════════════════════════════════════════════
     TRAP H — the conditional field must not be `required` while hidden.
     checkValidity() would fail on a control the browser cannot focus or
     scroll to, and the form would refuse to submit with nothing on screen
     explaining why.
     ══════════════════════════════════════════════════════════════════════ */
  function syncOther(focusIt) {
    var on = form.elements['Event type'].value === 'Something else';
    otherFld.hidden = !on;
    if (on) { otherIn.setAttribute('required', 'required'); if (focusIt) otherIn.focus(); }
    else { otherIn.removeAttribute('required'); otherIn.value = ''; otherFld.classList.remove('is-bad'); }
  }
  form.elements['Event type'].addEventListener('change', function () { syncOther(true); syncSelect(); });

  function syncSelect() {
    var s = form.elements['Event type'];
    s.classList.toggle('is-empty', s.value === '');
  }

  /* ── field state ── */
  var flds = [].slice.call(form.querySelectorAll('.fld'));
  function ctrl(f) { return f.querySelector('input,select,textarea'); }
  function syncFld(f) {
    var c = ctrl(f); if (!c) return;
    f.classList.toggle('is-filled', String(c.value || '').trim() !== '');
    if (f.dataset.touched === '1') f.classList.toggle('is-bad', !c.checkValidity());
  }
  flds.forEach(function (f) {
    var c = ctrl(f); if (!c) return;
    c.addEventListener('input', function () { syncFld(f); });
    c.addEventListener('change', function () { syncFld(f); });
    c.addEventListener('blur', function () { f.dataset.touched = '1'; syncFld(f); });
  });
  syncOther(false); syncSelect(); flds.forEach(syncFld);

  /* ── submit ── */
  function niceDate(iso) {
    try {
      var p = iso.split('-');
      return new Date(p[0], p[1] - 1, p[2])
        .toLocaleDateString('en-CA', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' });
    } catch (err) { return iso; }
  }

  function collect() {
    var data = {}, lines = [];
    sumEl.innerHTML = '';
    [].slice.call(form.elements).forEach(function (el) {
      if (!el.name || !el.value) return;
      var shown = el.name === 'Preferred date' ? niceDate(el.value) : el.value;
      data[el.name] = el.value;
      var row = document.createElement('div');
      var dt = document.createElement('dt'); dt.textContent = el.name;
      var dd = document.createElement('dd'); dd.textContent = shown;
      row.appendChild(dt); row.appendChild(dd);
      sumEl.appendChild(row);
      lines.push(dt.textContent + ': ' + shown);
    });
    return { data: data, text: lines.join('\n') };
  }

  /* delivered === true only on the resolved POST. The response is opaque, so
     that is not proof the row was written — the sheet is the only proof — but a
     REJECTED promise is a genuine failure and must never be dressed as success. */
  function confirmView(p, delivered, returning) {
    var first = (p.data.Name || '').trim().split(/\s+/)[0];
    root.getElementById('alia-mt').textContent =
      returning ? 'Already sent' : (delivered ? 'Request received' : 'One more step');
    root.querySelector('[data-msub]').textContent = returning
      ? 'This is the request you sent from this browser.'
      : (delivered ? 'It is with the events team.' : 'We could not submit that.');
    root.querySelector('[data-dtitle]').textContent = delivered
      ? (first ? 'Thank you, ' + first + '.' : 'Thank you.')
      : 'Give us a call.';
    root.querySelector('[data-dlede]').innerHTML = delivered
      ? ('Your request for <b>' + esc(p.data.Guests || '') + ' guests</b> on <b>' +
         esc(niceDate(p.data['Preferred date'] || '')) + '</b> is with our events team. ' +
         'We will come back to you at <b>' + esc(p.data.Email || '') + '</b>.')
      : ('The request did not reach us. Call <b>' + esc(CFG.phoneLabel) +
         '</b> and we will take the details down the line.');
    var again = root.querySelector('[data-dagain]');
    if (again) again.hidden = !returning;
    form.hidden = true;
    doneEl.hidden = false;
    doneEl.scrollIntoView({ block: 'nearest' });
  }

  /* A remembered request has only its data, not live form elements, so the
     summary needs its own renderer. */
  function rebuildSummary(p) {
    sumEl.innerHTML = '';
    Object.keys(p.data).forEach(function (k) {
      if (k === 'Site' || k === 'Page') return;   /* plumbing, not the guest's answers */
      var row = document.createElement('div');
      var dt = document.createElement('dt'); dt.textContent = k;
      var dd = document.createElement('dd');
      dd.textContent = k === 'Preferred date' ? niceDate(p.data[k]) : p.data[k];
      row.appendChild(dt); row.appendChild(dd);
      sumEl.appendChild(row);
    });
  }

  /* start over deliberately */
  (function () {
    var again = root.querySelector('[data-dagain]');
    if (!again) return;
    again.addEventListener('click', function () {
      forgetSent();
      form.reset();
      syncOther(false); syncSelect();
      flds.forEach(function (f) { f.dataset.touched = ''; f.classList.remove('is-bad', 'is-filled'); });
      openForm();
    });
  })();

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    flds.forEach(function (f) { f.dataset.touched = '1'; syncFld(f); });

    if (!form.checkValidity()) {
      var bad = form.querySelector('.fld.is-bad input,.fld.is-bad select,.fld.is-bad textarea');
      if (bad) bad.focus();
      return;
    }

    var payload = collect();

    /* Leads sheet: Received | Site | Page | Name | Company | Email | Phone |
       Event type | Event detail | Guests | Preferred date | Budget per head |
       Notes | Status. Received and Status are filled sheet-side and must not be
       sent. Site and Page are plumbing, added here rather than as inputs. */
    payload.data.Site = CFG.site;
    payload.data.Page = location.href;

    if (DEMO) { confirmView(payload, false); return; }

    sendBtn.setAttribute('disabled', 'disabled');
    sendBtn.textContent = 'Sending';
    /* text/plain avoids a CORS preflight, which Apps Script rejects outright.
       Do not "fix" this to application/json. */
    fetch(CFG.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(payload.data)
    }).then(function () {
      rememberSent(payload);
      confirmView(payload, true);
    }).catch(function () {
      confirmView(payload, false);
    }).then(function () {
      sendBtn.removeAttribute('disabled');
      sendBtn.textContent = 'Send request';
    });
  });

  }
})();
